<fa-layers [fixedWidth]="true">
   <fa-icon [icon]="primaryIcon" size="lg"></fa-icon>
   <fa-stack *ngIf="secondaryIcon !== null" class="sub-icon">
      <fa-icon [icon]="secondaryIcon" class="sub-icon-border" stackItemSize="lg"></fa-icon>
      <fa-icon [icon]="secondaryIcon" class="sub-icon-icon" stackItemSize="lg"></fa-icon>
   </fa-stack>
</fa-layers>
